import React from 'react';
import ProductionLogo from '../../assets/images/tekion-logo.gif';
import StagingLogo from '../../assets/images/Staging.png';
import renault from '../../assets/images/RENAULT_Staging.png';
import aurora from '../../assets/images/AURORA_Staging.png';
import gm from '../../assets/images/GM_Staging.png';
import './style.scss';
const TekionLogo = props => {
  const {
    apiBaseUrl,
    showProd = false
  } = props;
  const {
    PARTNERS_SITE
  } = process.env;
  let logo = '';
  let logoClassName = 'tekion-stage-logo';
  let defaultUrl = '/app/home';
  const {
    origin
  } = window.location;
  if (origin && origin.includes('tap.tekioncloud.com') || showProd) {
    logo = ProductionLogo;
    logoClassName = 'tekion-logo';
  } else if (PARTNERS_SITE === 'true') {
    const partnerType = apiBaseUrl.split('-')[0].split('//')[1];
    switch (partnerType) {
      case 'gm':
        logo = gm;
        break;
      case 'renault':
        logo = renault;
        break;
      case 'aurora':
        logo = aurora;
        break;
      default:
        logo = StagingLogo;
    }
    defaultUrl = '/home/mytasks';
  } else {
    logo = StagingLogo;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "header-menu-logo"
  }, /*#__PURE__*/React.createElement("a", {
    href: defaultUrl,
    className: logoClassName
  }, /*#__PURE__*/React.createElement("img", {
    src: logo,
    alt: __('tekion logo')
  }), logoClassName === 'tekion-logo' && /*#__PURE__*/React.createElement("h5", null, __('Automation Platform'))));
};
export default TekionLogo;